import React, { createContext, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { createTheme, StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import CustomShadows from './custom-shadows';
import componentsOverride from './overrides';
import { buildPalette } from './palette';
import Typography from './typography';

const ThemeModeContext = createContext();
export const useThemeMode = () => useContext(ThemeModeContext);

export default function ThemeCustomization({ children }) {
  const [mode, setMode] = useState(localStorage.getItem('themeMode') || 'light');
  const [config] = useState({
    fontFamily: `Lato`,
  });

  const handleToggleMode = () => {
    const newMode = mode === 'dark' ? 'light' : 'dark';
    setMode(newMode);
    localStorage.setItem('themeMode', newMode);
  };

  const themeTypography = useMemo(() => Typography(config.fontFamily), [config.fontFamily]);
  const palette = useMemo(() => buildPalette(mode, []));

  const themeOptions = useMemo(
    () => ({
      breakpoints: {
        values: {
          xs: 0,
          sm: 768,
          md: 1024,
          lg: 1266,
          xl: 1440
        }
      },
      shape: {
        borderRadius: 8
      },
      direction: 'ltr',
      mixins: {
        toolbar: {
          minHeight: 60,
          paddingTop: 8,
          paddingBottom: 8
        }
      },
      typography: themeTypography,
      palette: palette,
      customShadows: CustomShadows(palette, mode),
      cssVariables: true
    }),
    [themeTypography, palette]
  );

  const themes = createTheme(themeOptions);
  themes.components = componentsOverride(themes);

  return (
    <ThemeModeContext.Provider value={{ mode, handleToggleMode }}>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themes}> 
        <CssBaseline enableColorScheme />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
    </ThemeModeContext.Provider>
  );
}

ThemeCustomization.propTypes = { children: PropTypes.node };